<template>
  <Banner>
    <MDCSlot />
  </Banner>
</template>

<script lang="ts" setup>
import { Banner } from '@crearis/ui'
</script>
